module.exports = __webpack_public_path__ + "public/media/step_3_draw_volcano.low.ba39de13.mp4";